import PropTypes from 'prop-types';
import React from 'react';
import { Dialog } from '@blueprintjs/core'

class PopContainer extends React.Component{
  constructor(props){
    super(props)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.state = {
      content: null,
    }
  }
  getChildContext(){
    return {
      open: this.open,
      close: this.close,
    }
  }
  open(state){
    this.setState(state)
  }
  close(){
    this.setState({content: null})
  }
  render(){
    let {className, children} = this.props
    let {content, ...props} = this.state
    return (
      <div className={className}>
        {children}
        <Dialog
          isOpen={this.state.content !== null}
          {...props}
        >
          {content}
        </Dialog>
      </div>
    )
  }
}

PopContainer.childContextTypes = {
  open: PropTypes.func,
  close: PropTypes.func,
}

PopContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
}

export default PopContainer



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/PopContainer.js
 **/